export interface Role {
  id: number;
  facilityId: string;
  name: string;
  description?: string;
  permissionTypeIds: number[];
  permissionNames?: string[];
  isProtected: boolean;
  isActive: boolean;
  userCount?: number; // Number of users assigned to this role
  createdAt?: string;
  updatedAt?: string;
}
